import React, { useState, useEffect } from "react";
import { pageTitle } from "../../helpers/PageTitle";
import Section from "../Section";
import { FaCheckCircle } from "react-icons/fa";

const comparisonParams = [
    { label: "Price", key: "price" },
    { label: "Market Price", key: "market_price" },
    { label: "Tests Count", key: "testCounts" },
    { label: "Sample Types", key: "testSamples" },
    { label: "Report Time", key: "reportTime" },
];

export default function ComparePlan() {
    pageTitle("Compare Plan");

    const [packages, setPackages] = useState([]);

    useEffect(() => {
        const stored = localStorage.getItem("compareHealthPackages");
        if (stored) setPackages(JSON.parse(stored));
    }, []);

    return (
        <Section  topMd={150}
        topLg={70}
        topXl={105}>
            {/* 🔥 Hero Section */}
            <div className="hero-banner11">
                <h1>Compare Health Packages</h1>
                <p>
                    Easily compare tests, pricing, and benefits to choose the best health package for your needs.
                </p>
            </div>

            {/* 🔥 Compare Section */}
            <Section topMd={60} topLg={80} bottomMd={60} bottomLg={80}>
                <div className="compare-wrapper">

                    {/* Heading */}
                    <h2 className="compare-title">
                        Compare Health Packages
                    </h2>

                    {/* Table */}
                    <div className="compare-table-container">
                        <table className="compare-table">

                            {/* Header */}
                            <thead>
                                <tr>
                                    <th className="sticky-col">Parameter</th>

                                    {packages.map((pkg) => (
                                        <th key={pkg.id}>
                                            <div className="plan-header">
                                                <span className="plan-name">{pkg.name}</span>
                                                <div className="plan-price">₹{pkg.price}</div>
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            {/* Body */}
                            <tbody>
                                {comparisonParams.map((param, index) => (
                                    <tr key={param.key}>
                                        <td className="sticky-col">{param.label}</td>

                                        {packages.map((pkg) => (
                                            <td key={pkg.id}>
                                                {param.key === "testSamples"
                                                    ? pkg.testSamples?.join(", ") || "-"
                                                    : pkg[param.key] || "-"}
                                            </td>
                                        ))}
                                    </tr>
                                ))}

                                {/* Test Details */}
                                <tr className="test-row">
                                    <td className="sticky-col">Test Details</td>

                                   {packages.map((pkg) => (
  <td key={pkg.id}>
    <div
      style={{
        maxHeight: "300px",
        overflowY: "auto",
        paddingRight: "6px",
      }}
    >
      {pkg.testDetails?.slice(0, 50).map((t, i) => (
        <div key={i} className="test-item">
          <FaCheckCircle className="icon" size={16}/>
          {t.name}
        </div>
      ))}
    </div>
  </td>
))}
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Empty State */}
                    {packages.length === 0 && (
                        <div className="no-data">
                            No packages selected for comparison
                        </div>
                    )}
                </div>
            </Section>
        </Section>
    );
}